import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import sec08_img01 from "../../../../resources/img/Events/Marketing/sec08_img01.png";
import sec08_img02 from "../../../../resources/img/Events/Marketing/sec08_img02.png";
import sec08_img03 from "../../../../resources/img/Events/Marketing/sec08_img03.png";
import sec08_img04 from "../../../../resources/img/Events/Marketing/sec08_img04.png";
import sec08_img05 from "../../../../resources/img/Events/Marketing/sec08_img05.png";
import sec08_img06 from "../../../../resources/img/Events/Marketing/sec08_img06.png";
import sec08_img07 from "../../../../resources/img/Events/Marketing/sec08_img07.png";

export const Section08 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    const imageUp = {
        translateY: spring.x.to({
            range: [0, 0.85, 1],
            output: [0, 0, -10]
        }).to(x => `${x}vh`)
    }

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <animated.div className={`${styles.sec} ${styles.sec08} ${styles.rel} ${frame > 0.2 && styles['dark-gray']}`} style={{
                opacity: spring.x.to({
                    range: [0, 0.85, 1],
                    output: [1, 1, 0]
                }).to(x => x),
            }}>
                <animated.a href="#" className={styles.sec08__link} target="_blank" style={{
                    opacity: spring.x.to({
                        range: [0, 0.1, 1],
                        output: [0, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.1, 0.85, 1],
                        output: [10, 0, 0, -10]
                    }).to(x => `${x}vh`)
                }}>
                    <p className={`${styles.sec08__link__font01} ${styles.marginDel}`}>빗썸</p>
                    <span className={`${styles.sec08__link__font02} ${styles.notoBold}`}>마일리지</span>
                    <p className={`${styles.sec08__link__font03} ${styles.marginDel}`}>bithumb mileage</p>
                </animated.a>
                <div className={`${styles.sec08__images} ${styles['z-index-10']}`}>
                    <animated.img src={sec08_img01} className={`${styles.sec08__images__img01} ${styles.ab} ${frame > 0.34 && styles['sec08__images__img01--on']}`} alt="+1 bm" style={{
                        opacity: spring.x.to({
                            range: [0, 0.3, 0.32, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.3, 0.33, 0.34, 1],
                            output: [0, 0, 1.2, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img02} className={`${styles.sec08__images__img02} ${styles.ab} ${frame > 0.25 && styles['sec08__images__img02--on']}`} alt="+2 bm" style={{
                        opacity: spring.x.to({
                            range: [0, 0.13, 0.25, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.13, 0.21, 0.23, 1],
                            output: [0, 0, 1.3, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img03} className={`${styles.sec08__images__img03} ${styles.ab} ${frame > 0.25 && styles['sec08__images__img03--on']}`} alt="+3 bm" style={{
                        opacity: spring.x.to({
                            range: [0, 0.1, 0.25, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.1, 0.18, 0.2, 1],
                            output: [0, 0, 1.2, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img04} className={`${styles.sec08__images__img04} ${styles.ab}`} alt="dot" style={{
                        opacity: spring.x.to({
                            range: [0, 0.32, 0.35, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img05} className={`${styles.sec08__images__img05} ${styles.ab} ${frame > 0.27 && styles['sec08__images__img05--on']}`} alt="돌아가는 원" style={{
                        opacity: spring.x.to({
                            range: [0, 0.14, 0.25, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.16, 0.27, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img06} className={`${styles.sec08__images__img06} ${styles.ab}`} alt="고정 원" style={{
                        opacity: spring.x.to({
                            range: [0, 0.14, 0.2, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.14, 0.2, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                    <animated.img src={sec08_img07} className={`${styles.sec08__images__img07} ${styles.ab} ${frame > 0.31 && styles['sec08__images__img07--on']}`} alt="b" style={{
                        opacity: spring.x.to({
                            range: [0, 0.27, 0.3, 1],
                            output: [0, 0, 1, 1]
                        }).to(x => x),
                        scale: spring.x.to({
                            range: [0, 0.27, 0.305, 0.31, 1],
                            output: [0, 0, 1.2, 1, 1]
                        }).to(x => x),
                        ...imageUp
                    }} />
                </div>
            </animated.div>
        </animated.div>
    )
}